var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshot4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5116 23.9686C19.0186 23.4328 19.6052 22.9741 20.2534 22.6099C21.3542 21.9915 22.5956 21.6667 23.8582 21.6667C25.1209 21.6667 26.3622 21.9915 27.463 22.6099C27.9392 22.8774 28.3821 23.1958 28.7846 23.5585M20.4949 30.1309C20.2675 27.407 19.5887 25.6159 19.2166 24.9853C18.4243 23.6383 17.3108 22.5249 15.9831 21.7524C14.6555 20.9798 13.1583 20.5741 11.6355 20.5741C10.1127 20.5741 8.61547 20.9798 7.28779 21.7524C6.22765 22.3693 5.30406 23.2033 4.57152 24.2004L4.1071 24.8955M23.8582 18.2882C21.8258 18.2882 20.1781 16.6405 20.1781 14.608C20.1781 12.5755 21.8258 10.9279 23.8582 10.9279C25.8907 10.9279 27.5385 12.5755 27.5385 14.608C27.5385 16.6405 25.8907 18.2882 23.8582 18.2882ZM11.9518 17.1073C9.43318 17.1073 7.3914 15.0655 7.3914 12.5469C7.3914 10.0282 9.43318 7.98647 11.9518 7.98647C14.4705 7.98647 16.5122 10.0282 16.5122 12.5469C16.5122 15.0655 14.4705 17.1073 11.9518 17.1073ZM16 30.8598C7.79458 30.8598 1.14281 24.2081 1.14281 16.0027C1.14281 7.79728 7.79458 1.14551 16 1.14551C24.2054 1.14551 30.8571 7.79728 30.8571 16.0027C30.8571 24.2081 24.2054 30.8598 16 30.8598Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot4);
export default __webpack_public_path__ + "static/media/snapshot4.a457050e678e0b9d9b9aabcc96c10c6e.svg";
export { ForwardRef as ReactComponent };